// src/api_scripts/getqueueList.js
import { fetchAllPages } from "../paginationUtils";

const getqueueList = async (queueListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v3/contact-service-queue`;

  try {
    // Use the pagination utility to fetch all pages
    const queueListsArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Queues");
    console.log("Get Queues List API Response Data (all pages):", queueListsArray.length, "items");
    return queueListsArray;

  } catch (error) {
    console.error(`Error fetching Queues:`, error);
    throw error; // Re-throw the error to be caught by the calling function
  }
};

export default getqueueList;
